import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { MatRadioGroup } from "@angular/material/radio";
import {
  PackageResponse,
  PackageTypeEnum,
  WorkshopSystemEnum
} from "src/domain/client";
import { FormService } from "src/app/services/form.service";
import { IconService } from "src/app/services/icon.service";
import { SectionTogglerComponent } from "../../layout/section-toggler/section-toggler.component";
import { PackageContainerComponent } from "../../layout/package-container/package-container.component";
import { PackagesFilterPipe } from "src/app/pipes/packages-filter.pipe";

@Component({
  selector: "app-specs-wheel-section",
  templateUrl: "./specs-wheel-section.component.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SectionTogglerComponent,
    ReactiveFormsModule,
    MatRadioGroup,
    PackageContainerComponent,
    TranslateModule,
    PackagesFilterPipe
  ]
})
export class SpecsWheelSectionComponent {
  packages = input.required<PackageResponse[]>();

  toggle = signal(false);
  WorkshopSystemEnum = WorkshopSystemEnum;
  PackageTypeEnum = PackageTypeEnum;

  constructor(
    public formService: FormService,
    public iconService: IconService
  ) {}

  get form(): FormGroup {
    return this.formService.chooseSpecificationsForm.controls
      .wheelForm as FormGroup;
  }

  getPackageFormGroup(id: string): FormGroup {
    return this.form.get(id) as FormGroup;
  }
}
